/** Preset face values shown as quick-pick buttons (cents). */
export const GIFT_CARD_PRESET_AMOUNTS = [2500, 5000, 10000, 20000] as const;

/** Custom amount bounds (cents). */
export const GIFT_CARD_MIN_AMOUNT = 1000; // $10
export const GIFT_CARD_MAX_AMOUNT = 100000; // $1000

/** Stripe will reject charges below $0.50; guard the post-promo price. */
export const GIFT_CARD_MIN_PAID_AMOUNT = 50; // $0.50

/** Max days a buyer can schedule a gift card delivery into the future (PT-local). */
export const GIFT_CARD_DELIVERY_MAX_DAYS = 365;

/** Hour-of-day (PT) when scheduled gift cards are delivered. */
export const GIFT_CARD_DELIVERY_HOUR_PT = 8;
